import { render } from "./QaTestRunBoard.vue?vue&type=template&id=0bba9fa6&scoped=true"
import script from "./QaTestRunBoard.vue?vue&type=script&lang=js"
export * from "./QaTestRunBoard.vue?vue&type=script&lang=js"

import "./QaTestRunBoard.vue?vue&type=style&index=0&id=0bba9fa6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bba9fa6"]])

export default __exports__